/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Works_4Inputs */

const en_vc_status_works_4 = /** @type {(inputs: Vc_Status_Works_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SVG, PDF, PDF-compatible .ai, EPS, DXF and Affinity files`)
};

const zh_vc_status_works_4 = /** @type {(inputs: Vc_Status_Works_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SVG、PDF、PDF 兼容 .ai、EPS、DXF 和 Affinity 文件`)
};

/**
* | output |
* | --- |
* | "SVG, PDF, PDF-compatible .ai, EPS, DXF and Affinity files" |
*
* @param {Vc_Status_Works_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_works_4 = /** @type {((inputs?: Vc_Status_Works_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Works_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_works_4(inputs)
	return zh_vc_status_works_4(inputs)
});
export { vc_status_works_4 as "vc.status.works.4" }